module.exports = __webpack_public_path__ + "static/media/d4p.510124be.jpg";